import type {
	FacetSingleSelectFilterValue,
	FilterConfig,
	SearchQueryParams,
} from '@pages/VendorsSearch/containers/FilterPills/atoms';
import type {
	AppliedSingleSelectFilterValue,
	FilterStrategy,
} from '@pages/VendorsSearch/containers/FilterPills/strategies/filter-strategy';

export class FacetSingleSelectFilterStrategy implements FilterStrategy {
	static readonly type = 'facet-single-select';
	type = FacetSingleSelectFilterStrategy.type;
	readonly data: AppliedSingleSelectFilterValue;
	constructor(filterValue: FacetSingleSelectFilterValue, config: FilterConfig) {
		const { facetId } = filterValue;
		const option = config.filterOptions.find((o) => o.id === facetId);
		const value = {
			facetId,
			facetValue: option?.singular.slug || '',
			facetName: option?.name || '',
		};
		if (
			config.type !== FacetSingleSelectFilterStrategy.type ||
			!value.facetId ||
			!value.facetName ||
			!value.facetValue
		) {
			throw new Error('Invalid AppliedSingleSelectFilterValue data');
		}
		this.data = { value, config };
	}

	calculateCount(): number {
		return 1;
	}

	getData() {
		return this.data;
	}

	getAppliedFilterPills() {
		const { value, config } = this.data;
		return [
			{
				filterId: config.id,
				facetId: value.facetId,
				name: value.facetName,
			},
		];
	}

	getAppliedFacetIds() {
		return [this.data.value.facetId];
	}

	getSeoFacetIds() {
		return this.getAppliedFacetIds();
	}

	getAppliedFacetNames() {
		return [this.data.value.facetName];
	}

	getAppliedFacetValues() {
		return [this.data.value.facetValue];
	}

	getSearchQueryParams(): Partial<SearchQueryParams> {
		return {
			filters: [this.data.value.facetId],
		};
	}

	getUrlQueryParams(): { key: string; value: string }[] {
		const { value, config } = this.data;
		return [
			{
				key: config.id,
				value: value.facetValue,
			},
		];
	}

	getAppliedFiltersForTracking(): { [p: string]: string | string[] } {
		const { value, config } = this.data;
		return {
			[config.id]: [value.facetValue],
		};
	}
}
